import { useMemo } from "react";
import { useTokenContext } from "src/contexts/tokenContext";
import { createInstance } from "src/utils/axios";
export function useAxiosInstance() {
  const { accessToken, setAccessToken } = useTokenContext();
  const axiosInstance = useMemo(
    () => createInstance(accessToken, setAccessToken),
    [accessToken, setAccessToken],
  );
  return axiosInstance;
}
